import * as Yup from 'yup';

export const loginValidationSchema = Yup.object({
    email: Yup.string()
        .email('É necessário um email válido.')
        .required('Este campo é obrigatório.'),
    password: Yup.string().required('Este campo é obrigatório.'),
});
